/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { profilesArchive } from '../../axios/profilesArchive'
import type {
	ProfilesArchiveError,
	ProfilesArchivePathParams,
	ProfilesArchiveResponse,
} from '../../types/ProfilesArchive'

export const profilesArchiveMutationKey = () => [{ url: '/:organisation/profiles/:profile' }] as const

export type ProfilesArchiveMutationKey = ReturnType<typeof profilesArchiveMutationKey>

export type ProfilesArchiveVariables = {
	organisation: ProfilesArchivePathParams['organisation']
	profile: ProfilesArchivePathParams['profile']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::archive */
export function useProfilesArchive<TContext = unknown>(
	options?: UseMutationOptions<
		ProfilesArchiveResponse,
		AxiosError<ProfilesArchiveError>,
		ProfilesArchiveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: profilesArchiveMutationKey(),
		mutationFn: ({ organisation, profile }: ProfilesArchiveVariables) =>
			profilesArchive(organisation, profile, config).then(res => res.data),
		...options,
	})
}
